
        var result = require("!!../../../node_modules/css-loader/index.js!./dashboard.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.css
// module id = 722
// module chunks = 0